import styled from 'styled-components';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import GenericProgress from '../../../../common/GenericProgress';

const UsersCardLAB = ({ user }) => {
    const { name, city, country, progress } = user;

    const hasLocation = city || country;
    const locationText = [city, country].filter(Boolean).join(', ');

    return (
        <Card>
            <Body>
                <InfoStudent>
                    <Name>{name}</Name>
                    <Occupation>Estudiante LAB</Occupation>
                    <Address>
                        <FmdGoodIcon />
                        <span>
                            {hasLocation ? locationText : 'Sin ubicación'}
                        </span>
                    </Address>
                </InfoStudent>
                <CircleProgress>
                    <GenericProgress
                        variant="determinate"
                        fontSize={14}
                        progress={progress ?? 0}
                        size={60}
                    />
                </CircleProgress>
            </Body>
        </Card>
    );
};

export default UsersCardLAB;

const Card = styled.div`
    width: 100%;
    border-radius: 20px;
    padding: 1rem;
    box-sizing: border-box;
    background-color: #fff;
    border: solid 2px #616161;
    box-shadow:
        0px 0px 10px -6px rgba(0, 0, 0, 0.25),
        0px 12px 24px -15px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    height: 100%;
`;

const Body = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    border-bottom: solid 1px #c4c4c4;
    box-sizing: border-box;
    padding-bottom: 0.5rem;
    flex: 1;
`;

const Images = styled.div`
    flex-basis: 37%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 0.5rem;
`;

const InfoStudent = styled.div`
    flex-basis: 46%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
`;

const Name = styled.h4`
    font-size: 14px;
    font-weight: 700;
    color: #222;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
    margin: 0;
`;

const Occupation = styled.p`
    font-size: 12px;
    font-weight: 500;
    color: #616161;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
    margin: 0;
`;

const Address = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    justify-content: flex-start;

    svg {
        color: #616161;
        font-size: 16px;
    }
    span {
        color: #616161;
        font-size: 11px;
    }
`;

const CircleProgress = styled.div`
    flex-basis: 17%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const Footer = styled.div`
    box-sizing: border-box;
    width: 100%;
    padding-top: 0.5rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    p {
        color: #616161;
        font-size: 13px;
        margin: 0;
    }
`;
